export function flipBox() {
    let flipBoxes = document.querySelectorAll('.flipbox');

    for (let i = 0; i < flipBoxes.length; i++) {
        flipBoxes[i].addEventListener('click', function (e) {
            this.classList.toggle('flipped');
        });
        flipBoxes[i].addEventListener('keydown', function (e:KeyboardEvent) {
            if (e.keyCode === 13) {
                this.classList.toggle('flipped');
            }
        });
    }
}